import React, { useState } from "react";
import { Bot, CalendarDays } from "lucide-react";
import { SellerAssistantPanel } from "@/components/SellerAssistantPanel";
import { SellerViewingCalendarPanel } from "@/components/SellerViewingCalendarPanel";

const TABS = [
  { id: "chat", label: "Asszisztens", icon: Bot },
  { id: "calendar", label: "Naptár", icon: CalendarDays },
];

export function SellerAssistantHub() {
  const [tab, setTab] = useState("chat");

  return (
    <div
      data-testid="seller-assistant-hub"
      className="glass rounded-3xl border border-white/10 flex flex-row flex-1 min-h-[520px] overflow-hidden"
    >
      <div className="flex-1 min-w-0 flex flex-col min-h-0">
        {tab === "chat" ? (
          <SellerAssistantPanel embedded />
        ) : (
          <SellerViewingCalendarPanel />
        )}
      </div>
      <nav
        className="w-[4.25rem] shrink-0 border-l border-white/10 flex flex-col items-center gap-1 py-3 px-1.5 bg-black/20"
        aria-label="Asszisztens fülek"
      >
        {TABS.map(({ id, label, icon: Icon }) => {
          const active = tab === id;
          return (
            <button
              key={id}
              type="button"
              data-testid={`seller-hub-tab-${id}`}
              title={label}
              onClick={() => setTab(id)}
              className={`w-full flex flex-col items-center gap-1 py-2.5 px-1 rounded-xl text-[10px] leading-tight transition-colors ${
                active
                  ? "bg-violet-500/25 text-violet-100 border border-violet-400/35"
                  : "text-slate-500 hover:text-slate-200 hover:bg-white/[0.04] border border-transparent"
              }`}
            >
              <Icon className="w-5 h-5 shrink-0" strokeWidth={1.5} />
              <span className="text-center">{label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
